import React from 'react';
import moment from 'moment';
import { buildKeyFromStrings } from "../../../../utils/build-key-from-strings";

var buildWeekDayMappingMarkup = function buildWeekDayMappingMarkup() {
  return React.createElement("ul", {
    className: "DayPicker_weekHeader_ul"
  }, moment.weekdays(true).map(function (weekday, index) {
    return React.createElement("li", {
      className: "DayPicker_weekHeader_li",
      key: buildKeyFromStrings(weekday, index)
    }, React.createElement("small", null, moment().day(weekday).format('dd')));
  }));
};

export var renderMonthHeader = function renderMonthHeader(localeCode) {
  return function (_ref) {
    var month = _ref.month;
    month.locale(localeCode);
    return React.createElement("div", {
      className: "CalendarMonth_caption"
    }, React.createElement("strong", null, month.format('MMMM YYYY')), React.createElement("div", {
      className: "DayPicker_weekHeaders"
    }, React.createElement("div", {
      className: "DayPicker_weekHeader"
    }, buildWeekDayMappingMarkup())));
  };
};